import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { CalculationSubject, DictionaryType } from '../../../../../domain/dictionary.model';
import { InsuredProductMotor, VehicleDefinitionMode } from '../../../../../domain/product.domain';
import { AsideAction } from '../../../store/aside.action';
import { OfferState } from '../../../store/offer.state';

@Component({
    selector: 'app-motor-readonly',
    templateUrl: './motor-readonly.component.html',
    styleUrls: ['./motor-readonly.component.scss']
})
export class MotorReadonlyComponent implements OnInit {

    // @Select(OfferState.getReadonlyMotor) product: Observable<InsuredProductMotor>;

    product: InsuredProductMotor;

    subscriptions: Subscription[] = [];

    dictionaryTypes = DictionaryType;

    calculationSubject = CalculationSubject;

    vehicleDefinitionMode = VehicleDefinitionMode;

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(OfferState.getReadonlyMotor).subscribe(product => this.product = product)
        );
    }

    get continuation() {
        return this.product.configuration.continuation.selected
            ? CalculationSubject.CONTINUATION
            : CalculationSubject.NEW_POLICY;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    close() {
        this.store.dispatch(AsideAction.CloseRight());
    }

    get outOfEurotax() {
        // shouldn't happen, but still, lets set default
        if (this.product.configuration.vehicleDefinition.mode === null) {
            this.product.configuration.vehicleDefinition.mode = VehicleDefinitionMode.EUROTAX;
        }
        return this.product.configuration.vehicleDefinition.mode === VehicleDefinitionMode.MANUAL;
    }
}
